import { render, staticRenderFns } from "./DriverView.vue?vue&type=template&id=96e6ca48&scoped=true&"
import script from "./DriverView.vue?vue&type=script&lang=js&"
export * from "./DriverView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e6ca48",
  null
  
)

export default component.exports